module.exports = __webpack_public_path__ + "static/media/IMG_4664.fab669a6.JPG";